
//版权封禁任务：无法下载提示：根据版权方要求，无法帮您下载错误码：111154
//其他封禁任务：无法下载提示：根据相关法律法规和政策要求，无法帮您下载错误码：111151、111152、111153、111155、111156
//其他下载失败错误无法继续下载提示：描述（错误码）具体见：http://wiki.xunlei.cn/pages/viewpage.action?pageId=27569471
//https://alidocs.dingtalk.com/i/nodes/3Pl7jXNw6dBWxlyBN35mWvKAGqOzY0D9
import {safeJSONParse} from '@shared/utils'
export const DownloadError = {
  /**
     * 敏感资源，而被禁止下载（hub控制策略）
     */
  111151: '根据相关法律法规和政策要求，无法帮您下载',

  /**
     * 账号限制，而被禁止下载（hub控制策略）
     */
  111152: '根据相关法律法规和政策要求，无法帮您下载',

  /**
     * 区域限制，而被禁止下载（hub控制策略）
     */
  111153: '根据相关法律法规和政策要求，无法帮您下载',

  /**
     * 版权封堵，而被禁止下载（hub控制策略）
     */
  111154: '根据版权方要求，无法帮您下载',

  /**
     * 	反动封堵，而被禁止下载（hub控制策略）
     */
  111155: '根据相关法律法规和政策要求，无法帮您下载',

  /**
     * 黄色封堵，而被禁止下载（hub控制策略）
     */
  111156: '根据相关法律法规和政策要求，无法帮您下载',
  111098: '文件路径不存在 (种子文件不存在)',
  9103: '任务已存在',
  114010: 'BT子任务下载失败',
  114002: 'BT子文件下载失败',
  114004: 'BT文件解析失败',
  490: '下载任务已删除',

  9111: '下载任务数量超过上限',
  111130: '下载信息更新失败',
  111085: '存储空间不足',
  114009: 'BT子文件下载失败',
  111127: '续传任务失败',
  111176: '资源服务器连接中断',
  111136: '资源服务器连接失败',
  114011: '部分BT任务下载失败',
  9112: '配置参数错误',
  114006: '链接解析失败',
  //  下载任务异常(${ code })
}
// {
//     "code": 200,
//     "ret": 0,
//     "data": {
//         "total": 1,
//         "page_token": "5605532",
//         "list": [{
//             "biz": "transport_download",
//             "biz_group": "trt_download",
//             "job_id": "a4fed88bad4e5d47a6a7b47fe4a9e2a0",
//             "name": ".torrents/D53BFBB5D32ADE21CD187FC9C792E8F9572D1C89/.torrent",
//             "device_id": "891c168fc54c6c746ccf947c5832a6d8",
//             "app_id": "xl_thunder",
//             "progress": 0,
//             "expire": 86400,
//             "expire_at": 1678793059,
//             "status": 5,
//             "ext_data": "{\"url\":\"magnet:?xt=urn:btih:D53BFBB5D32ADE21CD187FC9C792E8F9572D1C89//\",\"dir\":\"/xos_storage/v1/0a8c8a3d-15f7-4adc-8d34-997b2d8079db/我的下载\",\"client\":\"{\\\"n\\\":\\\"xl_hezi.pc\\\",\\\"u\\\":\\\"284819474\\\"}\",\"name\":\".torrents/D53BFBB5D32ADE21CD187FC9C792E8F9572D1C89/.torrent\",\"id\":\"8903828ee56fe96978bd05afd40507fe3efb006c\",\"status\":\"failed\",\"speed\":0,\"speedup\":0,\"type\":\"file\",\"errno\":9112}",
//             "is_read": 0,
//             "updated_at": "2023-03-13T19:24:19+08:00"
//         }]
//     },
//     "msg": "ok"
// }

export const getErrorMessage = (extDataStr:string) => {
  // "{\"url\":\"magnet:?xt=urn:btih:D53BFBB5D32ADE21CD187FC9C792E8F9572D1C89//\",\"dir\":\"/xos_storage/v1/0a8c8a3d-15f7-4adc-8d34-997b2d8079db/我的下载\",\"client\":\"{\\\"n\\\":\\\"xl_hezi.pc\\\",\\\"u\\\":\\\"284819474\\\"}\",\"name\":\".torrents/D53BFBB5D32ADE21CD187FC9C792E8F9572D1C89/.torrent\",\"id\":\"8903828ee56fe96978bd05afd40507fe3efb006c\",\"status\":\"failed\",\"speed\":0,\"speedup\":0,\"type\":\"file\",\"errno\":9112}"
  const extData = safeJSONParse(extDataStr) as {errno: number}
  console.log('extData.errno', extData.errno)
  return DownloadError[extData.errno] || '解析失败'
}
// 任务已存在
export const TASK_ALREADY_EXISTS = 9103